import React from "react";
import ProgressiveImage from "react-progressive-image";
import { useLocation } from "react-router-dom";
import { WEBSITE_BASE_URL } from "../../../../api";
import Ink from "react-ink";
import BackButtonWithName from "../../../Elements/BackButtonWithName";
import placeHolderImg from "../../../../assets/img/placeholder.jpeg"
const AllMainCategories = () => {
  const location = useLocation();
  const items = location.state?.items || [];

  return (
    <div style={{ padding: "16px" }}>
      <BackButtonWithName title={localStorage.getItem("all_categories")}/>
      <div className="mt-5" style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {items.map((item, index) => (
          <div
            key={index}
            style={{
              padding: "16px",
              border: "1px solid #ddd",
              borderRadius: "8px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
              display: "flex", flexDirection: "row",
              gap: "16px", 
              alignItems:"center"
            }}
          >
              <div className="position-relative">
                      <div
                        className=""
                        style={{
                          borderRadius: "cd8px",
                          mixBlendMode: "darken",
                          opacity: "0.9",
                        }}
                      >
                        <ProgressiveImage
                          delay={200}
                          src={WEBSITE_BASE_URL + item.image}
                          placeholder={
                           placeHolderImg 
                          }
                        >
                          {(src, loading) => (
                            <img
                              className="shadow-sm"
                              src={src}
                              alt={item.name}
                              style={{
                                height: "76px",
                                width: "76px",
                                objectFit: "cover",
                                borderRadius: "18px",
                                zIndex: "9999999",
                              }}
                            />
                          )}
                        </ProgressiveImage>
                      </div>
                      <Ink style={{ color: "#aaaaaa" }} />
                    </div>
            <div style={{ fontWeight: "600", fontSize: "16px" }}>
              {item.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllMainCategories;
